import { http } from '../../lib/http.ts';
import type { FormSummary } from './types.ts';

// Thin wrappers around the forms endpoints. These intentionally do NOT
// catch/toast — axios rejects on non-2xx (unlike fetch(), which only
// rejects on network failure), so callers in mount.ts wrap these with
// try/catch and pick the same on-failure toast copy the legacy
// dashboard.html used at each call site.

export async function loadForms(): Promise<FormSummary[]> {
  const { data } = await http.get<FormSummary[]>('/api/forms');
  // If another service is squatting on the API port (or a SPA fallback
  // answers /api/forms with index.html and a 200), `data` is an HTML
  // string, not a forms array — treat that as the server being unreachable
  // rather than rendering one card per character.
  if (!Array.isArray(data)) throw new Error('Unexpected /api/forms response');
  return data;
}

export async function createForm(title: string): Promise<{ id: string }> {
  const { data } = await http.post<{ id: string }>('/api/forms', {
    title: title || 'Untitled Form',
  });
  return data;
}

export async function renameForm(id: string, title: string): Promise<void> {
  await http.patch(`/api/forms/${id}`, { title });
}

export async function deleteForm(id: string): Promise<void> {
  await http.delete(`/api/forms/${id}`);
}

// Used only by the HTML-import flow, to save the parsed structure onto the
// just-created form (the legacy code's second fetch, POST /api/forms/:id).
export async function saveFormStructure(id: string, body: unknown): Promise<void> {
  await http.post(`/api/forms/${id}`, body);
}
